<template>
    <div class="bg-data-item">
        <img :src="bgDataBG" alt="">
        <div class="bg-data-item-title">{{ title }}：</div>
        <div class="bg-data-item-content">
            <div class="bg-data-item-value">
                <countTo :startVal='startVal' :endVal='endVal' :duration='3000' :decimals="0"
                         :separator="separator"></countTo>
                <span v-if="decimals && endDecimal" style="position: relative;left: -0.15rem">.</span>
            </div>
            <div class="bg-data-item-suffix">
                <span v-if="decimals && endDecimal" style="color: #e4ac3e;position: relative;left: -0.12rem ;"><countTo :startVal='startDecimal' :endVal='endDecimal' :duration='3000' :decimals="0"></countTo>
                </span>
                <span :style="{marginLeft: decimals && endDecimal?'-0.12rem':'.1rem'}">{{ suffix }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import bgDataBG from "@/assets/images/big-data-bg.png";
import countTo from 'vue-count-to';

export default {
	name: "bg-data-item",
	components: {countTo},
	props: {
		title: {
			type: String,
			default: ''
		},
		suffix: {
			type: String,
			default: ''
		},
		separator: {
			type: String,
			default: ''
		},
		value: {
			type: Number,
			default: 0
		},
		decimals: {
			type: Number,
			default: 0
		}
	},
	watch: {
		value: {
			handler(val) {
				this.startVal = this.endVal
				this.endVal = val;
				if (this.decimals) {
					this.startDecimal = this.endDecimal
					this.endDecimal = Number(val.toFixed(2).split('.')[1] || 0)
				}
			},
			immediate: true
		}
	},
	data() {
		return {
			bgDataBG,
			startVal: 0,
			endVal: 0,
			startDecimal: 0,
			endDecimal: 0,
		}
	}
}
</script>

<style scoped lang="less">
.bg-data-item {
  position: relative;
  width: 4.27rem;
  height: 1.95rem;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  padding-left: .15rem;

  .bg-data-item-title {
    color: #cdcac3;
    font-size: .36rem;
    position: relative;
  }

  .bg-data-item-content {
    display: flex;
    align-items: baseline;
    justify-content: flex-end;
    position: relative;
    left: .05rem;
    margin-top: .1rem;

    .bg-data-item-value {
      color: #e4ac3e;
      font-size: .64rem;
      font-style: italic;
    }

    .bg-data-item-suffix {
      color: #cdcac3;
      font-size: .36rem;

    }
  }

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
